export * from './tag.module';

export * from './tag.component';
